import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { MasterlocationRepository } from '../../repositories';

@Injectable({ providedIn: 'root' })
export class DeleteMasterLocationUseCase implements UseCase<string, boolean> {
  constructor(private readonly masterLocationRepository: MasterlocationRepository) {}

  execute(params: string): Observable<boolean> {
    return this.masterLocationRepository.deleteMasterLocation(params);
  }
}
